'use strict';
var form = document.querySelector('.questions__form');
form.addEventListener('submit', function(event) {
    event.preventDefault();
    this.reset();
});
document.addEventListener('DOMContentLoaded', function() {
    var menu = document.querySelector('.page__menu');
    var burger = document.querySelector('.header__burger');
    var closeBtn = document.querySelector('.menu__close');
    var navLinks = document.querySelectorAll('.menu__nav .nav__link');
    var body = document.body;
    var scrollPosition = 0;
    var openMenu = function() {
        scrollPosition = window.scrollY;
        menu.classList.add('active');
        body.style.position = 'fixed';
        body.style.top = "-".concat(scrollPosition, "px");
        body.style.left = '0';
        body.style.right = '0';
    };
    var closeMenu = function() {
        menu.classList.remove('active');
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        window.scrollTo(0, scrollPosition);
    };
    burger.addEventListener('click', openMenu);
    closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closeMenu();
    });
    navLinks.forEach(function(link) {
        return link.addEventListener('click', closeMenu);
    });
});
document.addEventListener('DOMContentLoaded', function() {
    var navLinks = document.querySelectorAll('.menu__nav .nav__link');
    navLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            navLinks.forEach(function(l) {
                return l.classList.remove('active');
            });
            link.classList.add('active');
        });
    });
});

//# sourceMappingURL=Kickstarter.663ce27b.js.map
